export class GoogleAnalytics {
    init() {
        $(document).ready(function () {
            $('.gtag-analize').click(function (event, options) {
                options = options || {};
                if (!options.run_event) {
                    event.preventDefault()
                    let element
                    try {
                    
                        let eventName,eventCategory,eventLabel
                        if($(this).hasClass('button')){
                            element =  $(this).children() 
                            eventName = element.data('event') || 'click'
                            eventCategory = element.data('eventCategory')
                            eventLabel = element.text().trim()
                        }
                        else{
                            element = $(this)
                            eventName = element.data('event')
                            eventCategory = element.data('eventCategory')
                            eventLabel = element.data('eventLabel')
                        }
                      
                        gtag('event', eventName, {
                            'event_category': eventCategory, 'event_label': eventLabel, 'event_callback': function () {

                                if (element.is('a')) {
                                    if(element.prop('target') == '_blank'){
                                        window.open(element.attr('href'), '_blank');
                                    }
                                    else{
                                        location.href = element.attr('href');
                                    }
                                }
                                else {
                                    $(event.currentTarget).trigger(event.type, { 'run_event': true });
                                }
                            }
                        });
                    }
                    catch (err) {
                        console.log(err)
                    }
                }
            })
        })
    }
}

//class="gtag-analize" data-event="click" data-event-category="e-mail" data-event-label="kontakt@gosciniecmalinowka.pl" 

